import type { ChatDraft, StepKey } from './chatSteps';

const LINEAR_NEXT: Partial<Record<StepKey, StepKey>> = {
  ASK_TITLE: 'ASK_DESCRIPTION',
  ASK_DESCRIPTION: 'SELECT_PROJECT',
  SELECT_PHASE: 'ASK_IMAGES',
  AI_CONVERSE: 'ASK_IMAGES',
  ASK_IMAGES: 'CONFIRM',
  CONFIRM: 'DONE',
  DONE: 'DONE',
};

/**
 * Tính bước kế tiếp dựa trên bước hiện tại + draft đã thu thập.
 *
 * Ba nhánh THẬT (không tuyến tính):
 *  - SELECT_SERVICE: luôn vào CHOOSE_MODE — kể cả khi AI tắt, khách vẫn cần
 *    được chọn "tự mô tả" (form tự do) hay "từng bước"; AI chỉ là 1 trong 3
 *    lựa chọn và tự ẩn riêng ở UI khi `ChatbotConfig.ai_enabled` false.
 *  - CHOOSE_MODE: rẽ theo `draft.mode` user vừa chọn.
 *  - SELECT_PROJECT: bỏ qua SELECT_PHASE khi không chọn dự án (hành vi cũ,
 *    không đổi).
 * Mọi bước khác tra trong LINEAR_NEXT.
 */
export function getNextStep(current: StepKey, draft: ChatDraft): StepKey {
  if (current === 'SELECT_SERVICE') {
    return 'CHOOSE_MODE';
  }
  if (current === 'CHOOSE_MODE') {
    return draft.mode === 'ai' ? 'AI_CONVERSE' : 'ASK_TITLE';
  }
  if (current === 'SELECT_PROJECT') {
    return draft.projectId ? 'SELECT_PHASE' : 'ASK_IMAGES';
  }
  return LINEAR_NEXT[current] ?? current;
}

/**
 * Khi hội thoại AI dừng dang dở (hết lượt hoặc AI lỗi/tắt), tính bước đầu
 * tiên của luồng hỏi-từng-bước mà user CHƯA cung cấp — để không bắt họ nhập
 * lại cái AI đã thu được thành công trước đó.
 */
export function getFallbackStep(draft: ChatDraft): StepKey {
  if (!draft.rawTitle && !draft.refinedTitle) return 'ASK_TITLE';
  if (!draft.rawDescription && !draft.refinedDescription) return 'ASK_DESCRIPTION';
  return 'SELECT_PROJECT';
}
